import { Tabs } from '@wix/design-system';
import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { s as styleInject } from './style-inject.es-e7b07dd7.js';
import { SETTINGS_TAB } from './consts.js';
import { POLLS_SETTINGS_TABS, POLLS_SETTINGS_LAYOUT_TAB, POLLS_SETTINGS_DESIGN_TAB, POLLS_SETTINGS_SETTINGS_TAB } from './dataHooks.js';

var css_248z = ".nbv2D{--wds-list-item-section-padding-horizontal:0px;--ricos-thumbnail-picker-margin-top:18px;--ricos-toggle-button-margin-top:18px;--ricos-toggle-button-margin-bottom:18px}.zGk-J{--wsr-color-B10:var(--rcp-color-primary)}.zGk-J button:hover{--wsr-color-B10:var(--rcp-color-hover)}.YUOCy{--wds-input-value-font-size-medium:14px}";
var classes = {"content":"nbv2D","tabs":"zGk-J","input":"YUOCy"};
styleInject(css_248z);

const TabNavigation = ({ activeTab, onTabChange }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    Tabs,
    {
      dataHook: POLLS_SETTINGS_TABS,
      className: classes.tabs,
      hasDivider: true,
      minWidth: "100%",
      alignment: "center",
      type: "uniformFull",
      items: [
        {
          id: SETTINGS_TAB.layout,
          dataHook: POLLS_SETTINGS_LAYOUT_TAB,
          title: t("Poll_PollSettings_Tab_Layout_TabName")
        },
        {
          id: SETTINGS_TAB.design,
          dataHook: POLLS_SETTINGS_DESIGN_TAB,
          title: t("Poll_PollSettings_Tab_Design_TabName")
        },
        {
          id: SETTINGS_TAB.settings,
          dataHook: POLLS_SETTINGS_SETTINGS_TAB,
          title: t("Poll_PollSettings_Tab_Settings_TabName")
        }
      ],
      activeId: activeTab,
      onClick: (value) => onTabChange(value.id)
    }
  );
};

export { TabNavigation as T, classes as c };
//# sourceMappingURL=tab-navigation-f3eb4402.js.map
